import styled from "styled-components";

import "../../../../../../bgGlobal.css"

export const ModalAlert = styled.div`
      font-size: larger;
      color: darkorange;

    .exclamation-icon-modal {
      font-size: larger;
      color: darkorange;
    }
`;

export const Emitir = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: rgba(33, 35, 38, 0.1) 2px 10px 10px -10px;
  transform: translate(5%, 5%);
  width: 90%;
  max-height: 55vh;
  display: flex;
  flex-direction: column; /* Garantir que o conteúdo se organize em coluna */

  .scrollY {
    flex: 1; /* Permite que a área com overflow ocupe o espaço disponível */
    overflow-y: auto;
  }

  .scrollY::-webkit-scrollbar {
    width: 10px;
  }

  .scrollY::-webkit-scrollbar-track {
    background-color: var(--scrollbar-track-color, #f1f1f1);
  }

  .scrollY::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb-color, #c4c4c4);
    border-radius: 5px;
  }

  .scrollY::-webkit-scrollbar-thumb:hover {
    background: var(--scrollbar-thumb-hover-color, #555);
  }

  .displayFlex {
    display: flex;
    background: var(--bg-secundary);
    color: var(--bg-white);
    border-radius: 8px 8px 0px 0px;
  }

  .msgFilter{
  text-align:center;
  }

  .center{
  margin: 0 auto;
  }

  .inputSerach {
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .btn-close,
  .title {
    padding: 10px;
  }

  .title {
    width: 100%;
  }

  .close {
    font-size: 30px;
    color: var(--bg-white);
    cursor: pointer;
  }

  .modal-title {
    font-size: 20px;
    padding: 10px;
  }

  .title {
    span {
      position: relative;
      top: 7px;
    }
  }

  .btn-site-div {
    display: flex;
    justify-content: flex-end;
    margin: 10px 14px;

    .btn-site {
      background: var(--bg-secundary);
      color: var(--bg-white);
    }
  }

  .loading {
      position: absolute;
      right: 50%;
      top: 50%;
    }

    .tarefas-correlacionadas {
      background: var(--bg-secundary);
      color: var(--bg-white);
      font-size: 18px;
      font-weight: 400;
      padding: 0px 20px;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      height: 36px;
      margin-top: 76px;
      text-align: center;
    }
`;

export const ModalOverlayHeader = styled.div`
  position: fixed;
  width: 100vw;
  height: 1000px;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1000;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
  transition: opacity 0.5s ease, visibility 0.5s ease;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
`;

export const FormContent = styled.div`
  margin: 10px 70px;

  width{
    width: 10px;
    height: 10px;
  }


    .btn-model{
      padding: 10px;
      border-radius: 50%;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      font-size: 16px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      text-align: center;
      align-items: center;
      margin: 5px;
    }

    .bg-padrao{
      background: var(--bg-secundary);
      color: var(--bg-white);   
    }
    .form-content {
      display: flex;
      justify-content: space-between;
    }

    .justify-content{
      display: flex;
      justify-content: center;
    }

    .form-item {
      margin: 10px;
    }

    .btn-save {
      background: var(--bg-secundary);
      color: var(--bg-white);
      height: 40px;
      width: 200px;
      border-radius: 8px;
    }
  }

  .tooltip {
    position: absolute;
    right: 10%;
    background-color: #333;
    color: var(--bg-white);
    padding: 5px;
    border-radius: 4px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.float-buttons {
    display: inline-flex;
    align-items: flex-end;
    margin-left: 40px;
}

.float-button:hover .tooltip {
    opacity: 1;
}

.float-button:hover .tooltip {
    opacity: 1;
}

.button {
  background: var(--bg-white);
  color: rgb(111, 110, 110);
  padding: 10px 15px;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 5px;
  transition: background-color 0.3s;
  margin-bottom: 10px;
}

.button:hover {
    background-color: #22385121;
}

.flex-center{
  display: flex;
  justify-content: center;
}

.text-center-margin-3{
color: var(--bg-btn);
  text-align: center;
  margin: 3px;
}

`

export const Select = styled.div`
  display: flex;
  margin: 22px 6px;

  select {
    border: none;
    height: 40px;
    border-radius: 8px;
    padding: 10px;
    width: 112px;
    color: #737373;
  }

  select:hover {
    border: none;
  }
`;